import { productConstants } from "../constants";
import { productService } from "../services";

export const productActions = {
    getProductsOfPublicShop
};

function getProductsOfPublicShop(shop_id = 0) {
    return dispatch => {
        dispatch(request());
        productService.getProductsOfPublicShop(shop_id).then(
            res => dispatch(success(res)),
            err => dispatch(error(err))
        );
    };

    function request() {
        return { 
            type: productConstants.GET_PRODUCTS_OF_PUBLIC_SHOP_REQUEST
        };
    }
    function success(products) {
        return { 
            type: productConstants.GET_PRODUCTS_OF_PUBLIC_SHOP_SUCCESS,
            payload: mergeProductWithSortOrder(products)
        };
    }
    function error(err = {}) {
        return { 
            type: productConstants.GET_PRODUCTS_OF_PUBLIC_SHOP_ERROR,
            payload: err
        };
    }
}

function mergeProductWithSortOrder(products = {}){
    let data =  (products?.data || []).map((item) => {
        const product_order = products?.products_order?.find((order) => order?.product_id === item?.product_id) || {};
        return {
            ...item,
            sort_order: product_order?.sort_order || 0
        }
    }) || [];
    return data?.sort((a, b) => a.sort_order - b.sort_order);
}